import wx from 'weixin-js-sdk'

type MiniProgramNavigator = {
  navigateTo?: (options: { url: string }) => void
  redirectTo?: (options: { url: string }) => void
  switchTab?: (options: { url: string }) => void
  navigateBack?: (options?: {
    delta?: number
    fail?: (err?: unknown) => void
    success?: () => void
    complete?: () => void
  }) => void
}

type WechatSdkRuntime = {
  miniProgram?: MiniProgramNavigator
}

declare global {
  interface Window {
    wx?: WechatSdkRuntime
  }
}

const getWechatRuntime = (): WechatSdkRuntime | undefined => {
  return (wx as WechatSdkRuntime) || window.wx
}

export const bootstrapWechatSdk = () => {
  const runtime = getWechatRuntime()
  if (runtime && !window.wx) {
    window.wx = runtime
  }
  return runtime
}

export const getMiniProgram = (): MiniProgramNavigator | undefined => {
  return bootstrapWechatSdk()?.miniProgram
}

export const waitForMiniProgram = async (
  timeout = 1500,
  interval = 100
): Promise<MiniProgramNavigator | undefined> => {
  const start = Date.now()
  let miniProgram = getMiniProgram()

  while (!miniProgram && Date.now() - start < timeout) {
    await new Promise((resolve) => window.setTimeout(resolve, interval))
    miniProgram = getMiniProgram()
  }

  return miniProgram
}
